import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import GLightbox from 'glightbox';
import { onKonfigImagesApplied } from './_konfig.js';

function isVideoUrl(url) {
    return /youtube\.com|youtu\.be|vimeo\.com|player\.vimeo\.com/i.test(url || '');
}

function normalizeLightboxUrl(url) {
    if (!url) {
        return url;
    }

    try {
        const parsed = new URL(url);
        const host = parsed.hostname.replace(/^www\./, '');

        if (host.includes('youtu.be')) {
            const id = parsed.pathname.replace(/^\//, '');
            return id ? `https://www.youtube.com/watch?v=${id}` : url;
        }

        if (host.includes('youtube.com')) {
            const embedMatch = parsed.pathname.match(/\/embed\/([A-Za-z0-9_-]+)/);
            if (embedMatch) {
                return `https://www.youtube.com/watch?v=${embedMatch[1]}`;
            }
            if (parsed.searchParams.get('v')) {
                return `https://www.youtube.com/watch?v=${parsed.searchParams.get('v')}`;
            }
        }

        if (host.includes('vimeo.com')) {
            const idMatch = parsed.pathname.match(/\/(?:video\/)?(\d+)/);
            if (idMatch) {
                return `https://vimeo.com/${idMatch[1]}`;
            }
        }
    } catch (error) {
        return url;
    }

    return url;
}

function sortByVisualPosition(items) {
    return [...items].sort((a, b) => {
        const aRect = a.getBoundingClientRect();
        const bRect = b.getBoundingClientRect();
        const rowThreshold = 40;

        if (Math.abs(aRect.top - bRect.top) > rowThreshold) {
            return aRect.top - bRect.top;
        }

        return aRect.left - bRect.left;
    });
}

function initMixLightbox(grid) {
    if (grid._mixLightboxHandlers) {
        grid._mixLightboxHandlers.forEach(({ link, handler }) => {
            link.removeEventListener('click', handler);
        });
        grid._mixLightboxHandlers = null;
    }

    if (grid._mixLightbox) {
        grid._mixLightbox.destroy();
        grid._mixLightbox = null;
    }

    const links = sortByVisualPosition(grid.querySelectorAll('a.gallery-mix-lightbox'));
    if (!links.length) {
        return;
    }

    const lightbox = GLightbox({
        elements: links.map((link) => {
            const href = link.getAttribute('href');
            const type = link.getAttribute('data-type') || (isVideoUrl(href) ? 'video' : 'image');

            return {
                href: normalizeLightboxUrl(href),
                type,
            };
        }),
        touchNavigation: true,
        loop: true,
    });

    const handlers = links.map((link, index) => {
        const handler = (event) => {
            event.preventDefault();
            lightbox.openAt(index);
        };
        link.addEventListener('click', handler);
        return { link, handler };
    });

    grid._mixLightbox = lightbox;
    grid._mixLightboxHandlers = handlers;
}

function initGalleryMasonry() {
    document.querySelectorAll('.gallery--grid--mix').forEach((grid) => {
        if (grid.dataset.masonryInit) {
            return;
        }

        grid.dataset.masonryInit = '1';

        const msnry = new Masonry(grid, {
            itemSelector: '.gallery--item',
            columnWidth: '.gallery--sizer',
            gutter: '.gallery--gutter-sizer',
            percentPosition: true,
            transitionDuration: 0,
        });

        const layoutMasonry = () => msnry.layout();
        const refresh = () => {
            msnry.layout();
            initMixLightbox(grid);
        };

        imagesLoaded(grid).on('progress', layoutMasonry);
        imagesLoaded(grid).on('always', refresh);

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(refresh, 200);
        });
    });
}

jQuery(document).ready(initGalleryMasonry);

onKonfigImagesApplied(() => {
    document.querySelectorAll('.gallery--grid--mix').forEach((grid) => {
        if (typeof initMixLightbox === 'function') {
            initMixLightbox(grid);
        }
    });
});
